import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  onBeforeUnmount, onMounted, ref, watch,
} from 'vue';
import { mountCalendar } from '@/calendar/renderer';
import '@/calendar/calendar.css';

type CalendarContext = {
  id_staff?: number | null;
  id_branch?: number | null;
  id_patient?: number | null;
  date?: string;
};

type CalendarRequest = (
  event: 'snapshot' | 'command' | 'preview',
  payload: Record<string, unknown>,
  requestId: string,
) => Promise<unknown>;

type CalendarProps = {
  context: CalendarContext;
  request: CalendarRequest;
  refreshRevision?: number;
};

type CalendarEvents = {
  (event: 'event', data: { event: string; payload: Record<string, unknown> }): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarWidget',
  props: {
    context: {},
    request: { type: Function },
    refreshRevision: {}
  },
  emits: ["event"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const container = ref<HTMLElement | null>(null);
let calendar: ReturnType<typeof mountCalendar> | null = null;

function refresh() {
  return calendar?.refresh() ?? Promise.resolve(false);
}

function setContext(context: CalendarContext) {
  return calendar?.setContext(context) ?? Promise.resolve(false);
}

onMounted(() => {
  if (!container.value) return;
  calendar = mountCalendar(container.value, {
    context: props.context,
    request: (
      event: Parameters<CalendarRequest>[0],
      payload: Record<string, unknown>,
      requestId: string,
    ) => props.request(event, payload, requestId),
    onEvent: (event: string, payload: Record<string, unknown>) => emit('event', { event, payload }),
  });
});

watch(() => props.context, setContext, { deep: true });
watch(() => props.refreshRevision, refresh);

onBeforeUnmount(() => {
  calendar?.destroy();
  calendar = null;
});

__expose({ refresh, setContext });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "container",
    ref: container,
    class: "clinic-calendar-widget"
  }, null, 512))
}
}

})